import { createSelector } from 'reselect';
import { State } from 'redux/types';
import { CanvaState } from './types';

export const canvaSelector = (state: State): CanvaState => state.get('canva');

export const canvaProviderUserIdSelector = createSelector(
  canvaSelector,
  canva => canva.providerUserId,
);

export const canvaUserDataSelector = createSelector(canvaSelector, canva => ({
  accessToken: canva.accessToken,
  providerUserId: canva.providerUserId,
}));

export const isCreatingCanvaDesignSelector = createSelector(
  canvaSelector,
  canva => canva.isCreatingDesign,
);

export const isCanvaDesignInProgressSelector = createSelector(
  canvaSelector,
  canva => canva.isDesignInProgress,
);

export const isExportingCanvaDesignSelector = createSelector(
  canvaSelector,
  canva => canva.isExportingDesign,
);
